import { render, staticRenderFns } from "./PersonalCard.vue?vue&type=template&id=e4bb9eb2"
import script from "./PersonalCard.vue?vue&type=script&lang=js"
export * from "./PersonalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports